import { ThemeNames, ThemeType, } from '../types.js';
const name = ThemeNames.GoodLifePlus;
const displayName = 'Good Life Plus';
const type = ThemeType.Default;
const siteConfig = {
    gamblingCommissionUrl: 'www.gambleaware.org',
};
const socials = {
    facebookUrl: 'https://www.facebook.com/GoodLifePlusUK',
    instagramUrl: 'https://www.instagram.com/joingoodlifeplus/',
    youtubeUrl: 'https://www.youtube.com/channel/UCR5VzXqBMkIeHsiIAmIT2ig',
    xUrl: 'https://x.com/goodlifeplusuk',
};
// TODO: Move to CMS
const assets = {
    logo: '/assets/images/good-life-plus/logo.svg',
    logoLight: '/assets/images/good-life-plus/logo-light.svg',
    logoMobile: '/assets/images/good-life-plus/logo-sm.svg',
    logoCard: '/assets/images/good-life-plus/logo-card.svg',
    banner: '/assets/images/good-life-plus/banner.jpg',
    howToRedeem: [
        '/how-to-redeem/good-life-plus/redeem-step-1.png',
        '/how-to-redeem/good-life-plus/redeem-step-2.png',
        '/how-to-redeem/good-life-plus/redeem-step-3.png',
        '/how-to-redeem/good-life-plus/redeem-step-4.png',
    ],
    liveDrawWinners: '/assets/images/presenters/holly-cutout.png',
    comingSoon: '/assets/images/banners/coming-soon-horizontal.png',
    comingSoonLarge: '/assets/images/banners/coming-soon.png',
    loserImage: '/assets/images/loser-image.png',
};
const primitives = {
    theme: {
        extend: {
            colors: {
                white: '#F8FAFC',
                'pure-white': '#FFFFFF',
                primary: '#8C78FF', // purple
                'primary-light': '#CABDFF', // light purple
                'primary-lighter': '#ECE5FD', // lighter purple
                secondary: '#58FE70', // green
                'secondary-dark': '#009215', // dark green
                'secondary-light': '#EFFDF4', // green
                tertiary: '#FF7300', // orange
                'tertiary-light': '#FF9100', // light orange
                'tertiary-dark': '#FF7300', // orange
                black: '#1E293B',
                'light-black': '#566989',
                teal: '#00ECF0',
                'pastel-blue': '#78A7FF',
            },
        },
    },
};
const designTokens = {
    // General
    generalColorFocus: '#0085e5',
    // AbstractButton
    buttonBorderWidth: '1px',
    buttonBorderRadius: '1000px',
    buttonPrimaryDefaultBackground: '#58fe70',
    buttonPrimaryDefaultForeground: '#082330',
    buttonPrimaryDefaultColorBorder: '#ffffff00',
    buttonPrimaryHoverBackground: '#86fe9c',
    buttonPrimaryHoverForeground: '#082330',
    buttonPrimaryHoverColorBorder: '#ffffff00',
    buttonPrimaryPressedBackground: '#40d65d',
    buttonPrimaryPressedForeground: '#082330',
    buttonPrimaryPressedColorBorder: '#ffffff00',
    buttonSecondaryDefaultBackground: '#8c78ff',
    buttonSecondaryDefaultForeground: '#ffffff',
    buttonSecondaryDefaultColorBorder: '#ffffff00',
    buttonSecondaryHoverBackground: '#9680ff',
    buttonSecondaryHoverForeground: '#ffffff',
    buttonSecondaryHoverColorBorder: '#ffffff00',
    buttonSecondaryPressedBackground: '#745cff',
    buttonSecondaryPressedForeground: '#ffffff',
    buttonSecondaryPressedColorBorder: '#ffffff00',
    buttonTertiaryDefaultBackground: '#ffffff',
    buttonTertiaryDefaultForeground: '#082330',
    buttonTertiaryDefaultColorBorder: '#b6c6cf',
    buttonTertiaryHoverBackground: '#edf2f7',
    buttonTertiaryHoverForeground: '#082330',
    buttonTertiaryHoverColorBorder: '#b6c6cf',
    buttonTertiaryPressedBackground: '#e2eaed',
    buttonTertiaryPressedForeground: '#082330',
    buttonTertiaryPressedColorBorder: '#b6c6cf',
    // TextButton
    buttonTextFontFamily: 'Inter',
    buttonTextFontWeight: '700',
    buttonTextLineHeight: '1',
    buttonTextLgPaddingVertical: '12px',
    buttonTextLgPaddingHorizontal: '24px',
    buttonTextLgGap: '8px',
    buttonTextLgFontSize: '16px',
    buttonTextLgSizeIcon: '16px',
    buttonTextMdPaddingVertical: '8px',
    buttonTextMdPaddingHorizontal: '16px',
    buttonTextMdGap: '8px',
    buttonTextMdFontSize: '14px',
    buttonTextMdSizeIcon: '16px',
    buttonTextSmPaddingVertical: '6px',
    buttonTextSmPaddingHorizontal: '12px',
    buttonTextSmGap: '4px',
    buttonTextSmFontSize: '12px',
    buttonTextSmSizeIcon: '12px',
    // IconButton
    buttonIconXlPadding: '12px',
    buttonIconXlSizeIcon: '40px',
    buttonIconLgPadding: '8px',
    buttonIconLgSizeIcon: '24px',
    buttonIconMdPadding: '6px',
    buttonIconMdSizeIcon: '20px',
    buttonIconSmPadding: '4px',
    buttonIconSmSizeIcon: '16px',
    buttonIconTertiaryDefaultBackground: '#e2eaed',
    buttonIconTertiaryDefaultForeground: '#082330',
    buttonIconTertiaryDefaultColorBorder: '#e2eaed',
    buttonIconTertiaryHoverBackground: '#edf2f7',
    buttonIconTertiaryHoverForeground: '#082330',
    buttonIconTertiaryHoverColorBorder: '#edf2f7',
    buttonIconTertiaryPressedBackground: '#e2eaed',
    buttonIconTertiaryPressedForeground: '#082330',
    buttonIconTertiaryPressedColorBorder: '#e2eaed',
    // Checkbox
    checkboxSize: '24px',
    checkboxSizeTick: '16px',
    checkboxBorderRadius: '4px',
    checkboxBorderWidth: '1px',
    checkboxColorBorder: '#8c78ff',
    checkboxDefaultBackground: '#ffffff',
    checkboxHoverBackground: '#edf2f7',
    checkboxPressedBackground: '#e2eaed',
    checkboxSelectedBackground: '#8c78ff',
    checkboxSelectedForeground: '#ffffff',
    // Switch
    switchTrackPaddingHorizontal: '4px',
    switchTrackWidth: '56px',
    switchTrackHeight: '32px',
    switchTrackBorderWidth: '1px',
    switchTrackBorderRadius: '1000px',
    switchTrackBackground: '#e2eaed',
    switchTrackSelectedBackground: '#ff7300',
    switchHandleBorderRadius: '1000px',
    switchHandleSize: '24px',
    switchHandleDefaultBackground: '#082330',
    switchHandleHoverBackground: '#4c6475',
    switchHandlePressedBackground: '#01090c',
    switchHandleSelectedBackground: '#ffffff',
    switchHandleSelectedPressedBackground: '#e2eaed',
    // Tabs
    tabsItemForeground: '#082330',
    tabsItemSelector: '#ff7300',
    tabsItemSizeHighlight: '4px',
    tabsItemSizeIcon: '20px',
    tabsItemPaddingTop: '8px',
    tabsItemPaddingBottom: '12px',
    tabsItemPaddingHorizontal: '8px',
    tabsItemDefaultBackground: '#ffffff00',
    tabsItemHoverBackground: '#01090c0a',
    tabsItemPressedBackground: '#01090c14',
};
export default {
    assets,
    displayName,
    name,
    primitives,
    socials,
    type,
    designTokens,
    siteConfig,
};
